export const notificationConstants = {

    /*
     * Notification base types
     */
    NOTIFICATION_TYPES: {
        SUCCESS: 'success',
        INFO: 'info',
        WARN: 'warning',
        ERROR: 'error',
    }

};